export default function(fn, limitInMs = 100, context = this) {
  let wait = false
  return (...args) => {
    let fnWrapper = () => {
      fn.apply(context, args)
    }
    if (!wait) {
      fnWrapper()
      wait = true
      setTimeout(() => {
        wait = false
      }, limitInMs)
    }
  }
}
